import * as Sentry from '@sentry/react';

let isConsentGiven = false;

export const setSentryConsent = (hasConsent) => {
    isConsentGiven = hasConsent;
};

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: false,
    environment: import.meta.env.VITE_ENVIRONMENT,
    release: `eh-patients-app@${import.meta.env.VITE_VERSION}`,
    enabled: !!import.meta.env.VITE_SENTRY_DSN,
    denyUrls: [/matomo\.cloud/],
    beforeSend: (event) => {
        if (!isConsentGiven) return null;
        return event;
    },
    beforeSendTransaction: (event) => {
        if (!isConsentGiven) return null;
        return event;
    },
});
